<template>
  <div>
    <div v-if="isQuote" class="add_to_quote">
      <BaseButton
        v-if="!getIsUserLimited && !getIsAddToQuoteHidden"
        class="add_to_quote__button"
        :disabled="!isSkuPage || isDisabled"
        @onClick="addToQuote"
        buttonid="add-to-quote-pp"
      >
        <i class="material-icons">note_add</i>Add to Quote
      </BaseButton>
    </div>
    <div v-else class="add_to_cart">
      <div v-if="getIsUserLimited && !getIsAddToQuoteHidden">
        <div>
          <BaseButton
          data-id="add-to-cart-pp-disabled"
            class="add_to_cart__button__disabled"
            :disabled="true"
            :isPrimary="true"
            buttonid="add-to-cart-pp"
            @onClick="addToCart"
          >
            ADD TO CART
          </BaseButton>
        </div>
        <div>
          <BaseButton
            class="add_to_quote__button"
            :disabled="!isSkuPage"
            :isPrimary="false"
            buttonid="add-to-quote-pp"
            @onClick="addToQuote"
          >
            <i class="material-icons">note_add</i>
            ADD TO QUOTE
          </BaseButton>
        </div>
        <div class="add_to_cart__limited_user_text">
          {{ this.getProductInformationText }}
        </div>
      </div>
      <div v-if="!getIsAddToCartHidden && !getIsUserLimited && !isDisabled">
        <BaseButton
          data-id="add-to-cart-pp"
          class="add_to_cart__button"
          :disabled="!isSkuPage || countErrorDisableAddToCart"
          :isPrimary="true"
          buttonid="add-to-cart-pp"
          @onClick="addToCart"
          >ADD TO CART</BaseButton
        >
      </div>
      <div v-if="!getIsAddToCartHidden && !getIsUserLimited && isDisabled">
        <BaseButton
         data-id="add-to-cart-pp-disabled"
          class="add_to_cart__button__disabled"
          :disabled="true"
          :isPrimary="true"
          buttonid="add-to-cart-pp"
          >ADD TO CART</BaseButton
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButton from "../base/BaseButton";

export default {
  computed: {
    ...mapGetters("product", [
      "getProductSku",
      "getImage",
      "isSkuPage",
      "getProductPrice",
      "getProductTitle",
      "getIsAddToCartHidden",
      "getIsAddToQuoteHidden",
      "getProductSeries",
      "getProductInformationText"
    ]),
    ...mapGetters("user", ["getIsUserLimited"]),
    ...mapGetters("addToCartCount", [
      "countErrorDisableAddToCart",
      "getValidCartCount"
    ])
  },
  props: ["isQuote", "isDisabled"],
  methods: {
    addToQuote() {
      var isRackShelfItem = false;
      if (this.isFromRackShelfFinder()) {
        var rackShelfItem = this.getProductVariantCharacteritics(
          this.getProductSku.SkuCode
        );
        isRackShelfItem = true;
      }
      const fireAddToQuoteModalPopUpEvent = new CustomEvent(
        "fireAddToQuoteModalPopUp",
        {
          detail: {
            productNumber: this.getProductSku.SkuCode,
            quantity: this.getValidCartCount,
            scId: this.getProductSku.SkuCode,
            productTitle: this.getProductTitle,
            imageUrl: this.getImage[0].Url,
            imageAlt: this.getImage[0].Url,
            productPrice: this.getProductPrice.RawPrice,
            productMsrp: this.getProductPrice.RawMSRP,
            currency: this.getProductSku.Price.Currency,
            currencyCode: this.getProductSku.Price.CurrencyCode,
            brandLogo: this.getProductSeries.Brands[0].Url,
            rshProduct: rackShelfItem,
            isRSHItem: isRackShelfItem
          }
        }
      );
      document.body.dispatchEvent(fireAddToQuoteModalPopUpEvent);
    },
    addToCart() {
      var isRackShelfItem = false;
      if (this.isFromRackShelfFinder()) {
        var rackShelfItem = this.getProductVariantCharacteritics(
          this.getProductSku.SkuCode
        );
        isRackShelfItem = true;
      }
      const fireAddToCartModalPopUpEvent = new CustomEvent(
        "fireAddToCartModalPopUp",
        {
          detail: {
            productNumber: this.getProductSku.SkuCode,
            quantity: this.getValidCartCount,
            scId: this.getProductSku.SkuCode,
            productTitle: this.getProductTitle,
            imageUrl: this.getImage[0].Url,
            imageAlt: this.getImage[0].Url,
            productPrice: this.getProductPrice.RawPrice,
            productMsrp: this.getProductPrice.RawMSRP,
            currency: this.getProductSku.Price.Currency,
            currencyCode: this.getProductSku.Price.CurrencyCode,
            brandLogo: this.getProductSeries.Brands[0].Url,
            rshProduct: rackShelfItem,
            isRSHItem: isRackShelfItem
          }
        }
      );
      document.body.dispatchEvent(fireAddToCartModalPopUpEvent);
    },
    getProductVariantCharacteritics(itemNumber) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const make = urlParams.get("make") ? urlParams.get("make") : "";
      const model = urlParams.get("model") ? urlParams.get("model") : "";
      const item = {};
      item.IsProductVariant = true;
      item.ISPRODUCTVARIANTWITHCHARS = "Y";
      item.VARIANT_CHARACTERISTICS = [
        {
          KEY: "CATALOG_NUMBER",
          VALUE: itemNumber
        },
        {
          KEY: "RSH_MANUFACTURER",
          VALUE: make
        },
        {
          KEY: "RSH_MODEL",
          VALUE: model
        }
      ];
      return item;
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    // check if its a rack shelf item
    isFromRackShelfFinder() {
      const rackShelfModelParam = "model";
      const params = new URLSearchParams(window.location.search);
      return params.has(rackShelfModelParam);
    }
  },
  components: {
    BaseButton
  }
};
</script>

<style lang="scss" scoped>
.add_to_cart {
  &__limited_user_text {
    align-items: center;
    justify-content: center;
    width: 100% !important;
    font-family: $body;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 0;
  }
  &__button {
    &.btn-default {
      border-width: 2px;
    }
    &__disabled {
      background: #e6e6e6;
      border: none !important;
      border-radius: 0px;
      color: #545454;
      font-weight: bold;
      &[disabled] {
        pointer-events: none !important;
      }
    }
  }
}
.add_to_quote {
  width: 100%;
  @include media-breakpoint-up(sm) {
    margin: auto;
  }
  &__button {
    border-color: $primary;
    color: $primary;
    i {
      color: $primary;
      font-size: 17px;
      margin-right: 8px;
      transition: all 0.3s ease;
    }
    @include media-breakpoint-down(sm) {
      margin-top: 16px;
    }
    @include media-breakpoint-up(sm) {
      margin-top: 16px;
    }
    &:hover {
      color: $white;
      background-color: $primary !important;
      border-color: $primary !important;
      i {
        color: $white;
      }
    }
    &:focus {
      background-color: $primary !important;
      border-color: $primary !important;
      i {
        color: $white !important;
      }
    }
    &[disabled] {
      pointer-events: none !important;
      background: #e6e6e6;
      border: none !important;
      border-radius: 0px;
      color: #545454;
      font-weight: bold;
      i {
        color: #545454 !important;
      }
    }
  }
}
</style>
